export default {
  users: {
    username: "",
    password: "",
    loggedIn: false
  },

  // lost: [
  //   {
  //   "userId": 1,
  //   "gender": "Male",
  //   "name": "Spot",
  //   "species": "Dog",
  //   "date": "06.19.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "missing dog",
  //   "lostId": 1
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Male",
  //   "name": "Fluffy",
  //   "species": "Cat",
  //   "date": "06.12.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "missing cat",
  //   "lostId": 2
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Female",
  //   "name": "Iggy",
  //   "species": "Iguana",
  //   "date": "01.05.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "missing iguana",
  //   "lostId": 3
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Female",
  //   "name": "Polly",
  //   "species": "Bird",
  //   "date": "03.16.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "missing bird",
  //   "lostId": 4
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Male",
  //   "name": "Buster",
  //   "species": "Dog",
  //   "date": "08.19.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "missing dog",
  //   "lostId": 5
  //   }
  //   ],


  // found: [
  //   {
  //   "userId": 1,
  //   "gender": "Female",
  //   "name": " ",
  //   "species": "Cat",
  //   "date": "06.12.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "found cat",
  //   "foundId": 1
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Male",
  //   "name": " ",
  //   "species": "Dog",
  //   "date": "06.12.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "found dog",
  //   "foundId": 2
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Female",
  //   "name": " ",
  //   "species": "Cat",
  //   "date": "03.16.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "found cat",
  //   "foundId": 3
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Male",
  //   "name": " ",
  //   "species": "Rabbit",
  //   "date": "08.19.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "found rabbit",
  //   "foundId": 4
  //   },
  //   {
  //   "userId": 1,
  //   "gender": "Female",
  //   "name": " ",
  //   "species": "Turtle",
  //   "date": "08.19.22",
  //   "email": "email@email.com",
  //   "phone": "555-555-5555",
  //   "comments": "found turtle",
  //   "foundId": 5
  //   }
  //   ],
 
}